/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      let total = parseInt(this.dataset.cartTotal, 10) || 0;

      // IMPORTANT: do NOT currency-convert here.
      // `data-minimum` and `data-cart-total` must be in the same currency + minor units already.
      let minimum = parseInt(this.dataset.minimum, 10) || 0;

      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');

      if (minimum > 0 && total < minimum) {
        percentage = total / minimum;

        // IMPORTANT: don't overwrite Liquid-rendered remaining amount.
        // If you keep this, you must guarantee correct currency formatting + units in JS.
        // let amountText = this.querySelector('.free-shipping--text span');
        // if (amountText) { ... }

        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'block';
          this.fullText.style.display = 'none';
        }
      } else {
        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'none';
          this.fullText.style.display = 'block';
        }
      }

      this.style.setProperty('--percentage', percentage);
    }
  }

  customElements.define('free-shipping', FreeShipping);
}